const stateListFormatter = (data, dataKey) => {
  const returnData = {};
  const dataSet = data ? JSON.parse(JSON.stringify(data)) : [];
  dataSet.forEach((element) => {
    element["label"] = element["state_name"];
  });
  returnData[dataKey] = [{ id: "", label: "--" }, ...dataSet];
  return returnData;
};

export default stateListFormatter;
